/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import useForm from "../../hooks/useForm";
import { isEmpty } from "../../utils/lodashExtend";
import Filters from "../Filters";
import { ControlTable } from "../Table";
import { getParams } from "../../utils/params";
import { activeChange, deleteAdContents, getAdContents } from "../../apis/admin/adManagers";
import AdContentDetail from "./AdContentDetail";
import systemAlert from "../../utils/systemAlert";
import { toast } from "../../utils/toast";
import { VIEW_TYPES } from "../../constants/AD_CONTENT";

const AdContentManagers = (props) => {

  const [fields] = useState([
    {
      title: "광고명",
      key: "title",
    },
    {
      title: "노출범위",
      key: "viewType",
      onValue: (v) => VIEW_TYPES.find(f => f.value === v)?.label || "-",
    },
    {
      title: "시작일",
      key: "startTime",
      type: "datetime"
    },
    {
      title: "종료일",
      key: "endTime",
      type: "datetime"
    },
    {
      title: "클릭 횟수",
      key: "histories",
      onValue: (d) => `${(d || []).length}회`
    },
    {
      title: "활성 여부",
      key: "isActive",
      onValue: (v) => v ? <span className="color-main-100">활성</span> : <span className="error">비활성</span>
    },
    {
      title: "등록일",
      key: "createdTime",
      type: "date"
    },
  ]);

  const [filters] = useState([
    {
      title: "광고명 검색",
      type: "input",
      placeholder: "광고명 입력",
      key: "search.title"
    },
    {
      title: "활성화 여부",
      type: "select",
      key: "search.isActive",
      options: {
        list: [{ label: "전체", value: "all" }, { label: "활성", value: 1 }, { label: "비활성", value: 0 }]
      }
    },
  ]);

  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);


  const {
    form,
    setSubmit,
    handleOnChange,
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
    reSubmit
  } = useForm({
    limit: 10,
    offset: 0,
    order: [{ createdTime: "desc" }]
  });

  const submit = (form) => {
    if (form.search?.isActive) {
      if (form.search?.isActive === "all") {
        delete form.search.isActive;
      } else {
        form.search.isActive = +form.search.isActive;
      }
    }

    getAdContents(getParams(form))
      .then(res => {
        const { list, count } = res.data;
        setList(list);
        setTotal(count);
      }).finally(() => setIsLoading(false));
  };



  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, []);

  const onDisable = () => {
    systemAlert(
      `광고컨텐츠 "${selectedList[0].title}" ${selectedList.length > 1 ? `외 ${selectedList.length - 1}개` : ""}를(을) 삭제 하시겠습니까?
      `,
      {
        buttons: [
          {
            label: "취소",
            color: "text"
          },
          {
            label: "삭제",
            color: "red",
            onClick: () => {
              deleteAdContents({ idxes: selectedList.map(item => item.idx) })
                .then(() => {
                  toast.success("삭제되었습니다.");
                  setSelectedList([]);
                  reSubmit();

                });
            }
          }
        ]
      },
    );
  };
  const onChangeActive = () => {
    systemAlert(
      `광고컨텐츠 "${selectedList[0].title}" ${selectedList.length > 1 ? `외 ${selectedList.length - 1}개` : ""}를(을) 비활성처리 하시겠습니까?
      `,
      {
        buttons: [
          {
            label: "취소",
            color: "text"
          },
          {
            label: "비활성",
            color: "red",
            onClick: () => {
              activeChange({ idxes: selectedList.map(item => item.idx), isActive: false })
                .then(() => {
                  toast.success("비활성 처리 되었습니다.");
                  setSelectedList([]);
                  reSubmit();

                });
            }
          }
        ]
      },
    );
  };

  const tableButtons = [
    {
      label: "컨텐츠 삭제",
      disabled: isEmpty(selectedList),
      color: "red",
      action: onDisable
    },
    {
      label: "비활성 처리",
      disabled: isEmpty(selectedList),
      color: "line",
      action: onChangeActive
    }, {
      label: "컨텐츠 등록",
      action: () => setDetailOpen(true)
    }];

  const handleOnSelect = (data) => {
    setSelectedItem(data);
    setDetailOpen(true);
  };



  return (
    <>
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        isHideAllCheck
        fields={fields}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        isControl={true}
        buttons={tableButtons}
        selectedList={selectedList}
        setSelected={setSelectedList}
        onSelect={handleOnSelect}
      />
      <AdContentDetail
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={reSubmit}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />
    </>
  );
};

export default AdContentManagers;